<template>
    <div class="appointments view-container">
        <div class="view-content">
            <iframe :src="$variables.links.appointmentsWebsiteLink" title="Agende já: Porto e Plano" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Appointments',
}
</script>

<style lang="scss">
.appointments {
    .view-content {
        padding: 0;

        iframe {
            width: 100vw;
            height: 100vh;
        }
    }
}
</style>
